/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-boolean-value */
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Page, Document, StyleSheet, View, Text } from '@react-pdf/renderer';
import DisplayEDITables from './EDI_unitop';
import HeaderSection from './pdf-header-footer/header-section';
import FooterSection from './pdf-header-footer/footer-section';
import DisplayPump from './pumps';
import DisplayCF from './cartige_filter';
import DisplayERD from './ERD';
import DisplayChemicalDosage from './chem_dose';
// import DisplayReports from './reports';
import DisplaySteamData from './steam_data';
import DisplayFeedProductWaste from './feed_product_waste';
import ProjectInfo from './project-info/project-info';
import ProgramDetails from './project-info/program_details';
import FlowsheetDesign from './flowsheet_summary/flowsheet-design/flowsheet_design';
import { ArialRegural, ChineseFonts, RationValHeight, RationValWidth } from './fonts/font';
import DisplayROTables from './ro-unit';
import MixerSplitter from './mixer-splitter/mixer-splitter';
import DisplayStripper from './stripper/stripper';
import RoElement from './ro_element/ro-element';
import ROStageLevelSummary from './ro-unit/ro-stage-level-summary';
import CLROStageLevelSummary from './ro-unit/clro-stage-level-summary';
import AntiscalantDosing from './antiscalant_dosing';
import { get_language_selection } from '../userData';

let dssroData = [];
let langualgeCheck = false;
const styles = StyleSheet.create({
  ProjectInfoPage: {
    lineHeight: 1.5,
    paddingBottom: RationValWidth(130),
  },
  page: {
    lineHeight: 1.5,
    paddingBottom: RationValWidth(198),
  },
  body: {
    marginHorizontal: RationValWidth(56),
    // paddingTop: RationValWidth(24),
  }
});
// in this function we are showing all unitop summary into multiple pages --> kranthi
const Invoice = (props) => {
  let serialNum = 1;
  let subSerialNum = 1;
  const { report_invoice, flowSheetImage, pdfoption, flowSheetSolvdData } = props;
  const invoiceData = report_invoice.report_dict;

  const { t } = useTranslation();
  const translateObject = t;
  // kranthi changes
  // This function checks if the number of true conditions is either 2 or 3.
  function checkConditions(...conditions) {
    // The filter(Boolean) will return an array of conditions that are true.
    const trueConditions = conditions.filter(Boolean);
    // If the number of true conditions is exactly 3, the function returns false.
    if (trueConditions.length === 3) {
      return false;
    }
    // If the number of true conditions is 2 or more (but not 3), the function returns true.
    return trueConditions.length >= 2;
  }
  // we are filtering the section from the option selected in menu --> kranthi
  // this function gives output of to show or not show section in pdf report --> kranthi
  const filterOptions = (SectionName) => {
    const filterValues = pdfoption.filter((val) => val.label === SectionName);
    if (filterValues.length === 0) return false;
    if (filterValues[0].disabled === false || filterValues[0].checked === false) { return false; }
    return true;
  };
  const checkDssROLoopData = () => {
    const dssroVal = Object.values(flowSheetSolvdData.unitop_output).filter((ele) => {
      return ele.unit_type === 'CLRO';
    });
    if (dssroVal.length > 0) {
      dssroData = dssroVal;
      return true;
    }
    return false;
  };
  langualgeCheck = get_language_selection() === 'zh' ? true : false;
  return (
    <Document>
      {/* ProjectInfo page start */}
      {(invoiceData && invoiceData.errors && invoiceData.errors.length >= 0) && (
        <Page size='A4' object-fit='fill' style={styles.ProjectInfoPage} bookmark='Preface'>
          <View style={{ height: RationValWidth(124) }} fixed />
          <View style={styles.body}>
            <ProjectInfo
              errors={invoiceData.errors}
              pageWidth={1140}
              info={invoiceData.coverpage_dict}
              project_details={invoiceData.project_details}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <View style={{
            color: '#002D62',
            fontSize: RationValWidth(10),
            height: RationValWidth(124),
            position: 'absolute',
            bottom: '0%',
            width: '100%',
            fontFamily: ArialRegural,
            padding: `${RationValWidth(50)}px ${RationValWidth(56)}px 0px`,
            marginTop: RationValWidth(56)
          }} fixed>
            <Text style={{ ...(langualgeCheck && { fontFamily: ChineseFonts }) }}>{translateObject('Trademark of Veolia')}</Text>
          </View>
        </Page>
      )}
      {/* Flowsheet Design Summary */}
      {invoiceData && invoiceData.flowsheet_config_dict && Object.keys(invoiceData.flowsheet_config_dict).length > 0 && filterOptions('Flowsheet Design Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. Flowsheet Design Summary`} >
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} fixed />
          <View style={styles.body}>
            <FlowsheetDesign
              pageWidth={1140}
              tableWidth={1140}
              flowsheet_config={invoiceData.flowsheet_config_dict}
              flowSheetImage={flowSheetImage}
              invoiceData={invoiceData}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} fixed />
        </Page>
      )}
      {/* Feed-Product-Waste Summary */}
      {invoiceData && invoiceData.feed_product_waste_summary && Object.keys(invoiceData.feed_product_waste_summary).length > 0 && filterOptions('Feed-Product-Waste Summary') && (
        <Page size='A4' object-fit="fill" style={styles.page} bookmark={`${serialNum}. Feed-Product-Waste Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <DisplayFeedProductWaste
              feed_product_waste={invoiceData.feed_product_waste_summary}
              unit_set_dict={invoiceData.system_units}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              coverpage_dict={invoiceData.coverpage_dict}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* RO Unit System-Level Summary */}
      {invoiceData && invoiceData.ro_hp && invoiceData.ro_summary && Object.keys(invoiceData.ro_hp).length > 1 && Object.keys(invoiceData.ro_summary).length > 0 && filterOptions('RO/NF Unit System-Level Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. RO/NF Unit System-Level Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body} wrap>
            <DisplayROTables
              invoice={invoiceData}
              pageWidth={1140}
              tableWidth={1140}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* RO Unit State-Level Summary */}
      {(invoiceData && invoiceData.ro_summary && invoiceData.ro_summary.ro_stage_dict) && filterOptions('RO/NF Unit Stage-Level Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. RO/NF Unit Stage-Level Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body} wrap>
            <ROStageLevelSummary
              rodata={invoiceData.ro_hp.ro_dict}
              system_units={invoiceData.system_units}
              ro_summary={invoiceData.ro_summary}
              pageWidth={1140}
              tableWidth={1140}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* DSSRO section summary */}
      {(invoiceData && invoiceData.clro_elem_summary && invoiceData.clro_elem_summary.clro_nos) && filterOptions('DSSRO Section Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. DSSRO Section Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body} wrap>
            <CLROStageLevelSummary
              system_units={invoiceData.system_units}
              clro_elem_summary={invoiceData.clro_elem_summary}
              clroOverView={invoiceData.clro_overview}
              clro_schematic={invoiceData.clro_schematic}
              pageWidth={1140}
              tableWidth={1140}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* EDI Unit System Level Summary */}
      {invoiceData && invoiceData.edi_summary && Object.keys(invoiceData.edi_summary).length > 0 && filterOptions('EDI Unit System-Level Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. EDI Unit System-Level Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <DisplayEDITables
              invoice={invoiceData}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* CHEM_DOSE Unit Summary */}
      {invoiceData && invoiceData.chem_dose_summary && Object.keys(invoiceData.chem_dose_summary).length > 0 && filterOptions('Chemical Dosing Unit Summary') && (
        <Page size='A4' style={styles.page} bookmark={`${serialNum}. Chemical Dosing Unit Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <DisplayChemicalDosage
              invoice={invoiceData}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* Antiscalant Dosage summary */}
      {(invoiceData && invoiceData.argo_summary) && filterOptions('Antiscalant Dosage Summary') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. Antiscalant Dosage Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body} wrap>
            <AntiscalantDosing
              argo_summary={invoiceData.argo_summary}
              pageWidth={1140}
              tableWidth={1140}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* CF Unit Summary */}
      {/* Pumps Unit Summary */}
      {/* ERD Unit Summary (WIP) */}
      {/* Stripper Unit Summary */}
      {/* Mixer-Splitter Unit Summary */}
      {invoiceData && ((Object.keys(invoiceData.cf_summary).length && filterOptions('CF Unit Summary')) || (invoiceData.pump_summary && Object.keys(invoiceData.pump_summary).length > 0 && filterOptions('Pump Unit Summary')) || (invoiceData.erd_summary && Object.keys(invoiceData.erd_summary).length > 0 && filterOptions('ERD Unit Summary (WIP)')) || (invoiceData.stripper_summary && Object.keys(invoiceData.stripper_summary).length > 0 && filterOptions('Stripper Unit Summary')) || (invoiceData.mixer_summary && Object.keys(invoiceData.mixer_summary).length > 0 && filterOptions('Mixer-Splitter Unit Summary'))) && (
        <Page size='A4' style={styles.page} >
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          {(Object.keys(invoiceData.cf_summary).length && filterOptions('CF Unit Summary')) && (
            <View style={[styles.body, { marginBottom: RationValWidth(56) }]} bookmark={`${serialNum}. CF Unit Summary`}>
              <DisplayCF
                cf_summary={invoiceData.cf_summary}
                serialNum={serialNum++}
                subSerialNum={subSerialNum}
                langualgeCheck={langualgeCheck}
                translateObject={translateObject}
              />
            </View>
          )}
          {invoiceData.pump_summary && Object.keys(invoiceData.pump_summary).length > 0 && filterOptions('Pump Unit Summary') && (
            <View style={[styles.body, { marginBottom: RationValWidth(56) }]} bookmark={`${serialNum}. Pump Unit Summary`}>
              <DisplayPump
                pumps={invoiceData.pump_summary}
                serialNum={serialNum++}
                subSerialNum={subSerialNum}
                langualgeCheck={langualgeCheck}
                translateObject={translateObject}
              />
            </View>
          )}
          {invoiceData && invoiceData.erd_summary && Object.keys(invoiceData.erd_summary).length > 0 && invoiceData.erd_summary['ERD Unit ID'] && filterOptions('ERD Unit Summary (WIP)') && (
            <View style={[styles.body, { marginBottom: RationValWidth(56) }]} break={(filterOptions('Pump Unit Summary') && filterOptions('CF Unit Summary'))} bookmark={`${serialNum}. ERD Unit Summary (WIP)`}>
              <DisplayERD
                erd_summary={invoiceData.erd_summary}
                serialNum={serialNum++}
                subSerialNum={subSerialNum}
                langualgeCheck={langualgeCheck}
                translateObject={translateObject}
              />
            </View>
          )}
          {invoiceData.stripper_summary && Object.keys(invoiceData.stripper_summary).length > 0 && filterOptions('Stripper Unit Summary') && (
            <View style={[styles.body, { marginBottom: RationValWidth(56) }]} bookmark={`${serialNum}. Stripper Unit Summary`}
              break={checkConditions(filterOptions('Pump Unit Summary'), filterOptions('CF Unit Summary'), filterOptions('ERD Unit Summary (WIP)'))}>
              <DisplayStripper
                stripper={invoiceData.stripper_summary}
                serialNum={serialNum++}
                subSerialNum={subSerialNum}
                langualgeCheck={langualgeCheck}
                translateObject={translateObject}
              />
            </View>
          )}
          {invoiceData.mixer_summary && invoiceData.mixer_summary.mixer_nos && invoiceData.mixer_summary['Mixer-Splitter Unit ID'] && Object.keys(invoiceData.mixer_summary).length > 0 && filterOptions('Mixer-Splitter Unit Summary') && (
            <View style={[styles.body]} bookmark={`${serialNum}. Mixer-Splitter Unit Summary`}
              break={checkConditions(filterOptions('Pump Unit Summary'), filterOptions('CF Unit Summary'), filterOptions('ERD Unit Summary (WIP)'), filterOptions('Stripper Unit Summary'))}>
              <MixerSplitter
                mixer_splitter={invoiceData.mixer_summary}
                pageWidth={1140}
                tableWidth={900}
                serialNum={serialNum++}
                subSerialNum={subSerialNum}
                langualgeCheck={langualgeCheck}
                translateObject={translateObject}
              />
            </View>
          )}
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* Top-Level Section: Detailed RO Element-Level Data */}
      {(invoiceData && invoiceData.ro_elem_summary && Object.keys(invoiceData.ro_elem_summary).length > 0) && filterOptions('Detailed RO/NF Element-Level Data') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. Detailed RO/NF Element-Level Data`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <RoElement
              ro_elem_summary={invoiceData.ro_elem_summary}
              pageWidth={1140}
              tableWidth={1140}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/* Steam Data Summary */}
      {invoiceData && invoiceData.stream_output && Object.keys(invoiceData.stream_output).length > 0 && filterOptions('Detailed Stream Data') && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}. Detailed Stream Data`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <DisplaySteamData
              heading='Detailed Stream Data'
              subHeading=''
              stream_ouput_data={invoiceData.stream_output}
              stream_input_dict={invoiceData.stream_input_dict}
              unit_set_dict={invoiceData.system_units}
              ediOutputData={invoiceData.ediOutputData}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
              breakflag={false}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {/*  DSSRO Loop Summary  */}
      {filterOptions('DSSRO Loop Summary') && checkDssROLoopData() && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${serialNum}.  DSSRO Loop Summary`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          {(() => {
            let flag = false;
            if (filterOptions('DSSRO Loop Summary') && checkDssROLoopData()) {
              flag = true;
              return dssroData.map((ele) => {
                return (
                  <View style={styles.body}>
                    <DisplaySteamData
                      heading='DSSRO Loop Summary'
                      subHeading={`${ele.output_user.name} ${translateObject('Permeate Stream (Loop wise) Summary')}`}
                      stream_ouput_data={ele.output_user.perm_loop_data}
                      stream_input_dict={invoiceData.stream_input_dict}
                      unit_set_dict={invoiceData.system_units}
                      ediOutputData={invoiceData.ediOutputData}
                      serialNum={serialNum}
                      subSerialNum={subSerialNum++}
                      langualgeCheck={langualgeCheck}
                      translateObject={translateObject}
                    />
                    <DisplaySteamData
                      heading='DSSRO Loop Summary'
                      subHeading={`${ele.output_user.name} ${translateObject('Concentrate Stream (Loop wise) Summary')}`}
                      stream_ouput_data={ele.output_user.conc_loop_data}
                      stream_input_dict={invoiceData.stream_input_dict}
                      unit_set_dict={invoiceData.system_units}
                      ediOutputData={invoiceData.ediOutputData}
                      serialNum={serialNum}
                      subSerialNum={subSerialNum++}
                      langualgeCheck={langualgeCheck}
                      translateObject={translateObject}
                    />
                  </View>
                );
              });
            }
            if (flag) {
              serialNum++;
            }
          })()}
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}

      {/* Errors & Warnings Unit Summary */}
      {invoiceData && invoiceData.coverpage_dict && invoiceData.coverpage_dict.project_info && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark={`${++serialNum}. Winflows Design Simulator Program details`}>
          <HeaderSection version={invoiceData.project_details} langualgeCheck={langualgeCheck}
            translateObject={translateObject} />
          <View style={styles.body}>
            <ProgramDetails
              info={invoiceData.coverpage_dict}
              project_details={invoiceData.project_details}
              serialNum={serialNum} subSerialNum={subSerialNum}
              langualgeCheck={langualgeCheck}
              translateObject={translateObject}
            />
            {/* <DisplayReports
              errors={invoiceData.errors}
              serialNum={serialNum++}
              subSerialNum={subSerialNum}
            /> */}
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} version={invoiceData.project_details} />
        </Page>
      )}
      {!invoiceData && (
        <Page size='A4' object-fit='fill'>
          <HeaderSection version='' />
          <View style={styles.body}>
            <Text>Something Wrong...</Text>
          </View>
          <FooterSection langualgeCheck={langualgeCheck}
            translateObject={translateObject} blank='empty' version='' />
        </Page>
      )}
    </Document>
  );
};
export default Invoice;